import { sendLog } from "../common/http-requests";
import {
  loggingRequestType,
  loggingResponseType,
} from "../common/type";

// 編集可能かどうかの確認（userIdが0でないかどうか）
// ページ表示時のハンドリングも考慮して、backend ではなく frontend で対応しておく。
export const checkValidUserId = async (
  userId: number,
  userEmail: string,
  funcAuth0Token: any,
  funcSetFeedbackInfo: any,
  feedbackInfo: any
) => {
  if (userId > 0) {
    return true;
  }

  let log_text = "Invalid user id. email:" + userEmail;
  const requestParams: loggingRequestType = {
    log_text,
  };
  const result: loggingResponseType = await sendLog(
    await funcAuth0Token(),
    requestParams
  );

  funcSetFeedbackInfo({
    ...feedbackInfo,
    open: true,
    text: "ユーザ情報が不正です。ログアウト後、再ログインしてください。",
    type: "error",
  });
  return false;
};

export const formatGrade = (grade: number, t: any): string => {
  return grade + t("common.grade");
};

export const formatSemester = (semesterNum: string, t: any): string => {
  return t("common.semester_" + semesterNum);
};

export const formatSeTsPeriodGradeGraduation = (earned_period: any, earned_grade: any, graduation_status: any, t: any): string => {
  return `${earned_period} (${earned_grade}${t("common.grade")})${graduation_status ? ' ' + t("sets.beforeGraduation") : ''}`;
};

export const formatPeriodGradeSemester = (period: number, grade: number, semester : string, t: any): string => {
  return `${period}(${formatGrade(Number(grade), t)})${formatSemester(semester, t)}`;
};

export const splitFormatPeriodGradeSemester = (periodGradeSemester: string, t: any): string => {
  const [period, grade, semester] = periodGradeSemester.split('_');
  return `${period}(${formatGrade(Number(grade), t)})${formatSemester(semester, t)}`;
};

export const splitFormatPeriodSemester = (periodSemester: string, t: any): string => {
  const [period, semester] = periodSemester.split('_');
  return `${period} ${formatSemester(semester, t)}`;
};

export const pageMt = (isDesktop: boolean): number => isDesktop ? 8 : 14;
